import { Injectable } from '@angular/core';
import { UserConfigurationAPIService } from '../API/UserConfigurationAPI.service';

@Injectable({
  providedIn: 'root'
})
export class UserConfigurationsService{
  configUrl: string;
  public clientes: any = [];

    constructor(private userConfigurationService: UserConfigurationAPIService) {
  }

  getUserRoles() {
    return this.userConfigurationService.getUserRoles();
  }

  public GetByUserIdWithDefault() {
    return this.userConfigurationService.GetByUserIdWithDefault();
  }

}
